import {
    DependentIds,
    EntityType,
    selectQuestionGroupSequenceNumber,
    selectQuestionSequenceNumber,
} from "features/qualityForm/qualityFormSlice";
import { useStrings } from "features/i18n/useStrings";

import { ErrorAction, ErrorBox } from "./VisibilityConflictErrorBox";
import strings from "./VisibilityConflictErrorBox.strings";
import { useAppSelector } from "app/hooks";

function DeleteQuestionConflicts({
    questionId,
    entityType,
}: {
    questionId: string;
    entityType: EntityType;
}) {
    const t = useStrings(strings);

    const questionSequenceNumber = useAppSelector((state) =>
        selectQuestionSequenceNumber(state.qualityForm)(questionId)
    );

    const errorMessage = t.labels.visibilityConditionErrorMessage.delete({
        referredEntityType: t.labels.entityType[ErrorAction.Delete][entityType],
        dependentEntityType: t.labels.entityType[EntityType.Question],
        dependentSequenceNumber:
            questionSequenceNumber?.questionGroupNumber +
            "." +
            questionSequenceNumber?.questionSequenceNumber,
    });
    return <li>{errorMessage}</li>;
}

function DeleteQuestionGroupConflicts({
    questionGroupId,
    entityType,
}: {
    questionGroupId: string;
    entityType: EntityType;
}) {
    const t = useStrings(strings);

    const questionGroupSequenceNumber = useAppSelector(
        (state) =>
            selectQuestionGroupSequenceNumber(state.qualityForm)(
                questionGroupId
            ) ?? ""
    );
    const errorMessage = t.labels.visibilityConditionErrorMessage.delete({
        referredEntityType: t.labels.entityType[ErrorAction.Delete][entityType],
        dependentEntityType: t.labels.entityType[EntityType.QuestionGroup],
        dependentSequenceNumber: questionGroupSequenceNumber?.toString(),
    });
    return <li>{errorMessage}</li>;
}

// TODO : we may wonna update the fonts for the error messages
export function DeletionVisibilityConflictErrorBox({
    conflictingIds,
    entityType,
    clearVisibilityConflicts,
}: {
    conflictingIds: DependentIds;
    entityType: EntityType;
    clearVisibilityConflicts: () => void;
}) {
    const errorListItems = conflictingIds.questionGroupIds.map((qg) => (
        <DeleteQuestionGroupConflicts
            questionGroupId={qg}
            entityType={entityType}
            key={qg}
        />
    ));
    const questionErrorListItems = conflictingIds.questionIds.map((q) => (
        <DeleteQuestionConflicts
            questionId={q}
            entityType={entityType}
            key={q}
        />
    ));
    return (
        <ErrorBox
            errorMessages={
                <>
                    {errorListItems}
                    {questionErrorListItems}
                </>
            }
            clearSourceError={clearVisibilityConflicts}
        />
    );
}
